import { Injectable } from '@angular/core';
import {ApiService} from './api.service';
import {LocaldbService} from './localdb.service';
import {TranslateService} from '@ngx-translate/core';
import {StorageService} from "./storage.service";

@Injectable({
  providedIn: 'root'
})
export class GetDataService {
  public disclaimer = '';

  constructor(
    private localdbService: LocaldbService,
    private apiService: ApiService,
    private storageService: StorageService,
    private translateService: TranslateService
  ) { }

  async getDataDisclaimer() {
    const result = await this.localdbService.getUserConfigs('disclaimer');
    if (result === null) {
      const apiResult = await this.apiService.getDisclaimer();
      if (apiResult !== null) {
        return apiResult;
      } else {
        return this.translateService.instant('CONFIG.DISCLAIMER');
      }
    } else {
      return result;
    }
  }

  async getDataAbout() {
    const result = await this.localdbService.getUserConfigs('about');
    if (result === null) {
      const apiResult = await this.apiService.getAbout();
      if (apiResult !== null) {
        return apiResult;
      } else {
        return this.translateService.instant('CONFIG.ABOUT');
      }
    } else {
      return result;
    }
  }

  async getDataAppHints() {
    const result = await this.localdbService.getUserConfigs('apphints');
    if (result === null) {
      const apiResult = await this.apiService.getAppHints();
      if (apiResult !== null) {
        return apiResult;
      } else {
        return this.translateService.instant('CONFIG.APP_HINTS');
      }
    } else {
      return result;
    }
  }

  async getDataReferences() {
    const result = await this.localdbService.getUserConfigs('credentials');
    if (result === null) {
      const apiResult = await this.apiService.getReferences();
      if (apiResult !== null) {
        return apiResult;
      } else {
        return this.translateService.instant('CONFIG.REFERENCES');
      }
    } else {
      return result;
    }
  }

  async getDataPrivacy() {
    const result = await this.localdbService.getUserConfigs('dsgvo');
    if (result === null) {
      const apiResult = await this.apiService.getDataPrivacy();
      if (apiResult !== null) {
        return apiResult;
      } else {
        return this.translateService.instant('CONFIG.DATA_PRIVACY');
      }
    } else {
      return result;
    }
  }

  async doGetMenu() {
    const result = await this.storageService.appMenu();
    if (result !== null) {
      return result;
    } else {
      return await this.apiService.getMenu();
    }
  }

  async doIndicationSearch(searchText) {
    const result = await this.localdbService.indicationSearch(searchText);
    if (result !== null) {
      return result;
    } else {
      return await this.apiService.indicationSearch(searchText);
    }
  }

  async doAtcSearch(searchText) {
    const result = await this.localdbService.atcCodeSearch(searchText);
    if (result !== null) {
      return result;
    } else {
      return await this.apiService.atcCodeSearch(searchText);
    }
  }

  async doSubstanceSearch(searchText) {
    const result = await this.localdbService.substanceSearch(searchText);
    if (result !== null) {
      return result;
    } else {
      return await this.apiService.substanceSearch(searchText);
    }
  }

  async doIcdSearch(searchText) {
    const result = await this.localdbService.icdCodeSearch(searchText);
    if (result !== null) {
      return result;
    } else {
      return await this.apiService.icdCodeSearch(searchText);
    }
  }

  async doDetailsSearch(id, type) {
    const result = await this.localdbService.detailSearch(id);
    if (result !== null) {
      return result;
    } else {
      return await this.apiService.detailsSearch(id, type);
    }
  }
}
